var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LoginHeader'),_vm._v(" "),_c('div',{staticClass:"relative",attrs:{"id":"layout-login"}},[_c('nuxt',{key:_vm.route.fullPath})],1),_vm._v(" "),_c('LoginFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }